import React from "react";

const AiLoader = () => {
  return (
    <div
      style={{
        position: "absolute",
        background: "#f5f8ff",
        height: "100vh",
        width: "100%",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: "100%",
          margin: "auto",
          backgroundColor: "#f5f8ff",
          zIndex: "9",
        }}
      >
        <svg
          version="1.1"
          id="L9"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          enableBackground="new 0 0 0 0"
          xmlSpace="preserve"
          width="300px" // Set the width
          height="20px" // Set the height
          style={{
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            position: "absolute",
            margin: "auto",
          }}
        >
          <circle
            fill="#0053ed"
            cx="30"
            cy="50"
            r="12"
          >
            <animate
              attributeName="cx"
              attributeType="XML"
              values="30;90;30"
              dur="3s"
              repeatCount="indefinite"
            />
          </circle>
          <circle
            fill="#0053ed"
            cx="60"
            cy="50"
            r="12"
          >
            <animate
              attributeName="cx"
              attributeType="XML"
              values="30;90;30"
              dur="3s"
              repeatCount="indefinite"
              begin="-1.5s"
            />
          </circle>
          <circle
            fill="#0053ed"
            cx="90"
            cy="50"
            r="12"
          >
            <animate
              attributeName="cx"
              attributeType="XML"
              values="30;90;30"
              dur="3s"
              repeatCount="indefinite"
              begin="-1s"
            />
          </circle>
        </svg>
      </div>
    </div>
  );
};

export default AiLoader;
